<script setup>
import {defineProps} from "vue";
import { UseProductStore } from "@/stores/productStore";
import PriceFormatter from "@/components/PriceFormatter.vue";
import {useI18n} from "vue-i18n";

defineProps({
  product: {
    type: Object,
    required: true
  },
  page: {
    type:String,
    required: true
  }
});

const productStore = UseProductStore();
const { t } = useI18n();
const nonRefundable = (product) => product.refundable === false;

</script>

<template>
  <div  class="flex items-center justify-between" :class="nonRefundable(product) ? 'opacity-25' : ''">
      <span class="relative flex items-start space-x-4 w-full">
        <!-- Product Image -->
        <span class="grid justify-center">
          <img
              :src="product.image"
              :alt="product.productName"
              class="w-32"
          />
          <p class="text-center text-bw-black responsive-body-xxsmall mt-1 text-nowrap">
            (SKU) {{ product.sku }}
          </p>
        </span>

        <!-- Product Details & Price -->
        <div class="flex flex-col min-w-0 max-w-full w-full">
          <div class="flex flex-wrap justify-between w-full">
            <!-- Product Name -->
            <span class="responsive-body-small text-wrap max-w-full">
              <span class="text-bw-black font-bold self-start responsive-body-medium ">
                {{ product.productName }}
              </span>
              <p class="text-bw-grey">{{ product.color }} | {{ t('productsPage.size') }} {{ product.size }}</p>
            </span>


          </div>
        </div>
      </span>

    <PriceFormatter :price="product.price" class="responsive-body-large text-bw-black font-bold mr-2 ml-2 sm:mr-5 whitespace-nowrap"/>

    <input
        v-if="page==='ProductsPage'"
        type="checkbox"
        v-model="productStore.isChecked[product.id]"
        :id="'product-' + product.id"
        :name="'product-' + product.id"
        class="accent-bw-black mx-2 checkbox"
        :disabled="nonRefundable(product)"
        :class="nonRefundable(product) ? 'cursor-not-allowed' : ''"
        @change="productStore.toggleProduct(product)"
    />
  </div>


</template>

<style scoped>

</style>